let React =    require("react");

let Avatar =   require("../Avatar.jsx");
let Dropdown = require("../buttons/generic/Dropdown.jsx");

let DataActionUtil = require("../../util/DataActionUtil.js")
let ApplicationContext = require("../../config/ApplicationContext.js");

class MemberHub extends React.Component {

    constructor(){
        super();
        this.deleteMember = this.deleteMember.bind(this);
        this.cancelInvitationMember = this.cancelInvitationMember.bind(this);
    }
    options(){
        let { isView = true, name: userName, id: userId, state = "Contributor", pendingNewOwner = false,
                hubId, hubName, setConfirmation, setLoading, handleError
            } = this.props;

        // backend may have lowercase states, so capitolize
        if(isView) return state.charAt(0).toUpperCase() + state.slice(1);

        let data = {hub: {name: hubName, id:hubId}, newOwner: {name: userName, id: userId} };

        let tootip = false;
        let optionName = "Owner";
        let method = "transferOwnershipHub";

        if(pendingNewOwner){
            optionName = "Contributor";
            state = "Pending";
            method = "cancelTransferOwnershipHub";
            tootip = `${userName} has not yet accepted ownership of this ${fullHubAlias}. To cancel the invitation, change their status back to contributor.`;
        }

        let onClick = () => DataActionUtil[method](handleError, data, setConfirmation, setLoading);

        return state === "owner"? "Owner":
                <Dropdown name={state}
                    generalTooltip={tootip}
                    options={[{name: optionName, onClick}, {name: state, selected: true}]}/>
    }

    isOwnEntry(){
        if(!ApplicationContext.getUserData()) return false;
        return this.props.id === ApplicationContext.getUserData().id;
    }

    deleteMember(){
        let { hubId, setLoading, id:userId, name, handleError} = this.props;
        DataActionUtil.deleteMember(handleError, {userId, name, hubId, isOwnEntry: this.isOwnEntry()}, setLoading);
    }

    cancelInvitationMember(){
        let { hubId, setLoading, handleError, lookup = ""} = this.props;
        DataActionUtil.cancelInvitationMember(handleError, {lookup, hubId}, setLoading)
    }

    render() {
        let { type = "member", isView = true, email, avatar, name, state} = this.props;
        if(type === "member"){
            return  <div className={this.isOwnEntry()? "memberHub ownEntry": "memberHub"}>
                        <div className="memberHub__info">
                            <Avatar url={avatar}/>
                            <p>{name}</p>
                        </div>
                        <div className="memberHub__email">
                            <p>{email}</p>
                        </div>
                        <div className="memberHub__status">
                            {this.options()}
                        </div>
                        { ((isView && this.isOwnEntry()) || !isView) && state !== "owner" &&
                            <button className="memberHub__remove" onClick={this.deleteMember}></button>}
                    </div>
        }else if(!/(canceled|accepted)/.test(state)){
            return  <div className="memberHub invites">
                        <div className="memberHub__info">
                            <Avatar url={avatar}/>
                        </div>
                        <div className="memberHub__email">
                            <p>{email}</p>
                        </div>
                        <div className="memberHub__status" data-state={state}>
                            {state.charAt(0).toUpperCase() + state.slice(1)}
                        </div>
                        {!isView && <button className="memberHub__remove" onClick={this.cancelInvitationMember}></button>}
                    </div>
        }

        return null;
    }
}

module.exports = MemberHub;
